<template>
 <div class="flex items-center">
      <span
        class="inline-block mr-1"
        v-html="params.data.currency_details.code"
      ></span>
      {{ params.data.amount }}
    </div>
    <!-- <div class="flex items-center">
      {{ params.data.currency_code.toUpperCase() }}
      {{ params.data.amount }}
    </div> -->
</template>

<script>
export default {
  name: 'AmountCell'
}
</script>